module.exports = __webpack_public_path__ + "static/assets/ec861fda30a651fb2cf0b4458fd66458.svg";